global.Warning = class Warning extends Error {
  constructor(message) {
    super(message);
    this.name = 'Warning';
  }
};
global.colors = require('../../static/colors.json');
global.sizes = require('../../static/sizes.json');
